import React, {Fragment, useEffect} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {SubscriptionForm} from "./SubscriptionForm";
import {useModelCreateEngine} from "../common/hooks/useModelCreateEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {SubscriptionDataUtility} from "../common/SubscriptionDataUtility";

export let CreateSubscription = function (props) {
    const modelCreateEngine = useModelCreateEngine(
        ApiUtility.createSubscription,
        'subscription',
        props.afterSuccessfulSave
    );
    const renderableData = modelCreateEngine.renderableData;

    useEffect(() => {
        if (props.fromFpInvoiceId) {
            renderableData.updateAndRender({loading: true})
            ApiUtility.getFpInvoiceForSubscription(props.fromFpInvoiceId)
                .then((invoiceData) => {
                    renderableData.updateAndRender({
                        fpInvoice: invoiceData.fp_invoice,
                        fpInvoiceAsSubscriptionData: SubscriptionDataUtility.fpInvoiceToSubscriptionFormData(
                            invoiceData.fp_invoice,
                            invoiceData.invoice_lines_for_subscription
                        ),
                        loading: false
                    })
                })
                .catch((error) => {
                    renderableData.updateAndRender({loading: false})
                    console && console.log(error);
                    MessageDisplayerUtility.error(`An error occurred while loading the FP invoice.`);
                })
        }
    }, [props.fromFpInvoiceId]);

    if (props.fromFpInvoiceId && !renderableData.fpInvoiceAsSubscriptionData) {
        return (
            <ConditionalRenderer if={renderableData.loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
        )
    } else {
        return (
            <Fragment>
                <ConditionalRenderer if={renderableData.loading} renderer={() => (
                    <OverlayLoadingIndicator/>
                )}/>
                <SubscriptionForm
                    cancel={props.cancel}
                    save={modelCreateEngine.createModel}
                    isNew={true}
                    headerText="New Subscription"
                    fpInvoice={renderableData.fpInvoice}
                    fpInvoiceAsSubscriptionData={renderableData.fpInvoiceAsSubscriptionData}
                />
            </Fragment>
        );
    }
};
